import { FC, ReactNode } from 'react'
import { IconProps } from '../Icon/index.js'

export const Section: FC<{
  children: ReactNode
  section: string
  name?: string
  icon?: IconProps['variant']
}> = ({ children }) => children
